import { render, staticRenderFns } from "./ui-breadcrumbs.vue?vue&type=template&id=740fe18a&scoped=true"
import script from "./ui-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./ui-breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./ui-breadcrumbs.vue?vue&type=style&index=0&id=740fe18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fe18a",
  null
  
)

export default component.exports